"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteNavigation = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SiteHeader = require("../SiteHeader");

var _SiteLeftSidebar = require("../SiteLeftSidebar");

var _Overlay = require("./components/Overlay");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var BREAKPOINT_DESKTOP = 832;

var SiteNavigation = function SiteNavigation(_ref) {
  var leftSidebarProps = _ref.leftSidebarProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      siteLeftSidebarOpen = _useState2[0],
      setSiteLeftSidebarOpen = _useState2[1];

  var toggleSiteLeftSidebarOpen = function toggleSiteLeftSidebarOpen() {
    setSiteLeftSidebarOpen(!siteLeftSidebarOpen);
  };

  var resizeListener = function resizeListener() {
    if (window.innerWidth > BREAKPOINT_DESKTOP) {
      setSiteLeftSidebarOpen(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', resizeListener);
    }

    return function () {
      window.removeEventListener('resize', resizeListener);
    };
  }, []);
  var open = leftSidebarProps.open;
  var showSiteLeftSidebar = open === undefined ? siteLeftSidebarOpen : open;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_SiteHeader.SiteHeader, {
    onMenuClick: toggleSiteLeftSidebarOpen
  }), _react["default"].createElement(_SiteLeftSidebar.SiteLeftSidebar, _extends({}, leftSidebarProps, {
    open: showSiteLeftSidebar
  })), showSiteLeftSidebar && _react["default"].createElement(_Overlay.Overlay, null));
};

exports.SiteNavigation = SiteNavigation;